<template>
  <div class="et-lib__group" v-for="g in groups">
    <div class="et-lib__group-name">{{ g.groupName }}</div>
    <div class="et-lib__container">

      <figure v-for="item in g.children" class="et-lib__el" draggable="true" :data-type="item.type"
        :data-name="item.name">
        <img :src="getImgSrc(item)" alt="item.type">
        <p class="et-lib__label">{{ item.text }}</p>
      </figure>

    </div>

  </div>
</template>

<script setup>
import { getImgSrcByName } from '../../core/utils/img-load.js'

const props = defineProps({
  groups: {
    type: Array,
    default: () => []
  }
})

function getImgSrc(item) {
  return getImgSrcByName(item.libImg || item.type)
}


</script>

